import { put, call, take, takeEvery, select, delay } from "redux-saga/effects";
import { virtInstance, appInstance, davInstance } from "axios-config";
import * as actions from "store/actions";
import * as types from "./types";
import { NOTIFICATION_STATUS } from "App/componentsConfig";
import {
  showNotificationWithTimeout,
  showNotificationWithTimeoutOf5Seconds
} from "store/actions";
import { NOTIFICATIONS } from "consts";
import {
  closeEventSourceConnection,
  createEventSourceChannel
} from "store/eventStream";
import {
  decryptData,
  decodeHandler,
  waitForConnection,
  redirectToRPCVirtualizationConsole,
  redirectToNoVNCVirtualizationConsole,
  compareVersions
} from "utils";

export function* fetchVMsListStart(action) {
  try {
    let origin = "";
    try {
      origin = localStorage.getItem("origin");
    } catch (e) {
      console.log(e);
      origin = "mirror";
    }
    const response = yield virtInstance.get("/vmsInfo/?origin=" + origin);

    if (response.status === 200)
      yield put(actions.fetchVMsListSuccess(response.data));
    else yield put(actions.fetchVMsListFailure(response.status, response.msg));
  } catch (e) {
    console.log(e);
    yield put(
      actions.fetchVMsListFailure(500, NOTIFICATIONS.server.noResponse)
    );
  }
}

export function* createVMTaskStart(action) {
  try {
    const response = yield virtInstance.post("/create_vm/", action.data);

    if (response.status === 200) {
      yield put(
        actions.createVMTaskSuccess(
          response.data,
          action.data.client_uuid,
          action.redirect
        )
      );
      yield put(actions.createVmTaskIdList(response.data));
      yield put(
        showNotificationWithTimeout("virtualization", {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.virtualization.createVMTask.success
        })
      );
      //checking version and adding the list for RPC console boot progress
      try {
        const response = yield davInstance.get("/appversion/getAll");
        if (response.status === 200) {
          const email = yield select(
            state => state.account.userDetails.emailid
          );
          if (
            // compareVersions(response.data[0]?.version_no, "3.2.0") === 1
            email === "pramod.sr+prod99@idrive.com" ||
            email === "shreyak+prod2@idrive.com" ||
            email === "Shreyak+prod1@idrive.com"
          ) {
            if (action.redirect) {
              yield put(
                actions.setRPCConsoleAccessInProgress(
                  action.data.client_uuid,
                  response.data
                )
              );
            } else {
              yield put(
                actions.setRPCConsoleBootProgress(action.data.client_uuid)
              );
            }
          } else {
            if (action.redirect) {
              redirectToNoVNCVirtualizationConsole(
                response.data,
                action.data.client_uuid
              );
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      yield put(actions.createVMTaskFailure());
      yield put(
        showNotificationWithTimeout("virtualization", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: response.data.message
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(actions.createVMTaskFailure());
    yield put(
      showNotificationWithTimeout("virtualization", {
        status: NOTIFICATION_STATUS.failure.name,
        // msg: NOTIFICATIONS.virtualization.createVMTask.failure
        msg: NOTIFICATIONS.virtualization.createVMTask.failure
      })
    );
  }
}

export function* fetchTaskStatusListStart() {
  try {
    // Call createEventSourceChannel directly with the specific API endpoint
    const channel = yield call(createEventSourceChannel, "task-status");

    try {
      while (true && channel) {
        const eventData = yield take(channel);
        if (eventData.filter(val => val.status === "SUCCESS").length > 0) {
          yield put(
            showNotificationWithTimeout("virtualization", {
              status: NOTIFICATION_STATUS.success.name,
              msg: NOTIFICATIONS.virtualization.buildVm.success
            })
          );
          yield put(actions.fetchVMsListStart());
        } else if (
          eventData.filter(val => val.status === "FAILURE").length > 0
        ) {
          yield put(
            showNotificationWithTimeout("virtualization", {
              status: NOTIFICATION_STATUS.failure.name,
              msg: NOTIFICATIONS.virtualization.buildVm.failure
            })
          );
        }
        yield put(actions.fetchTaskStatusListSuccess(eventData));
      }
    } catch (e) {
      console.log(e);
    } finally {
      if (channel) {
        channel.close();
      }
    }
  } catch (error) {
    console.log(error);
    yield put(actions.fetchTaskStatusListFailure(error));
  }
}

export function* controlVMStart(action) {
  const hostname = action.data.hostname;
  try {
    delete action.data.hostname;
    const response = yield virtInstance.post("/control_vm/", action.data);
    if (response.status === 200) {
      yield put(actions.controlVMSuccess(response.data, action.data));
      yield put(
        showNotificationWithTimeout("virtualization", {
          status: NOTIFICATION_STATUS.success.name,
          msg: decodeHandler(response.data).replace(
            "Virtual Machine",
            "Virtual instance"
          )
        })
      );
      //checking version and adding the list for RPC console boot progress
      try {
        const response = yield davInstance.get("/appversion/getAll");
        if (response.status === 200) {
          const email = yield select(
            state => state.account.userDetails.emailid
          );
          if (
            // compareVersions(response.data[0]?.version_no, "3.2.0") === 1 &&
            (email === "pramod.sr+prod99@idrive.com" ||
              email === "shreyak+prod2@idrive.com" ||
              email === "Shreyak+prod1@idrive.com") &&
            (action.data.action === "power_on" ||
              action.data.action === "reboot")
          )
            yield put(
              actions.setRPCConsoleBootProgress(action.data.client_uuid)
            );
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      yield put(actions.controlVMFailure("", action.data));
      yield put(
        showNotificationWithTimeout("virtualization", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: NOTIFICATIONS.virtualization.controlVM.failure
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(actions.controlVMFailure("", action.data));
    yield put(
      showNotificationWithTimeout("virtualization", {
        status: NOTIFICATION_STATUS.failure.name,
        msg: NOTIFICATIONS.virtualization.controlVM.failure
      })
    );
  }
}

export function* deleteVMStart(action) {
  const hostname = action.data.hostname;
  try {
    delete action.data.hostname;
    const response = yield virtInstance.post("/destroy_vm/", action.data);
    if (response.status === 200) {
      yield put(actions.deleteVMSuccess(action.data));
      yield put(
        showNotificationWithTimeout("virtualization", {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.virtualization.deleteVM.success
        })
      );
    } else {
      yield put(actions.deleteVMFailure(action.data));
      yield put(
        showNotificationWithTimeout("virtualization", {
          status: NOTIFICATION_STATUS.failure.name,
          msg:
            "Unable to delete " +
            decodeHandler(hostname) +
            " virtual instance at the moment. Try again."
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(actions.deleteVMFailure(action.data));
    yield put(
      showNotificationWithTimeout("virtualization", {
        status: NOTIFICATION_STATUS.failure.name,
        msg:
          "Unable to delete " +
          decodeHandler +
          " virtual instance at the moment. Try again."
      })
    );
  }
}

export function* fetchVIRTRecoveryPointsStart(action) {
  const params = {
    clientUUID: action.clientUUID,
    restoreType: action.restoreType,
    loginId: decryptData(localStorage.getItem("mirrorId")),
    srpoint: action.params.serverIPAddress ? action.params.serverIPAddress : "",
    ...(action.scheduleUUID && { scheduleUUID: action.scheduleUUID })
  };
  try {
    const response = yield appInstance.get("/restore/recoveryPoints", {
      params: params
    });

    if (response.status === 200) {
      yield put(
        actions.fetchVIRTRecoveryPointsSuccess(response.data, {
          requestConfigParams: response.config.params
        })
      );
    } else
      yield put(
        actions.fetchVIRTRecoveryPointsFailure(
          {
            status: response.status,
            msg: response.data
          },
          {
            requestConfigParams: response.config.params
          }
        )
      );
  } catch (error) {
    console.log(error);
  }
}

export function* updateVMConfigurationsStart(action) {
  try {
    const response = yield virtInstance.post("/reconfigure_vm/", action.data);

    if (response.status === 200) {
      yield put(actions.updateVMConfigurationsSuccess(action.data));
      yield put(
        showNotificationWithTimeout("slidingPopup", {
          status: "success",
          msg: NOTIFICATIONS.virtualization.reconfigure.success
        })
      );
    } else if (response.status === 409) {
      yield put(actions.updateVMConfigurationsFailure(action.data));
      yield put(
        showNotificationWithTimeoutOf5Seconds("slidingPopup", {
          status: "failure",
          msg:
            "Unable to reconfigure the virtual instance as memory plan limit exceeded. Refresh the page and try again."
        })
      );
    } else {
      yield put(actions.updateVMConfigurationsFailure(action.data));
      yield put(
        showNotificationWithTimeout("slidingPopup", {
          status: "failure",
          msg: NOTIFICATIONS.virtualization.reconfigure.failure
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(actions.updateVMConfigurationsFailure(action.data));
  }
}

export function* rebuildVMStart(action) {
  const hostname = action.hostname;
  try {
    delete action.hostname;
    const response = yield virtInstance.post("/rebuild_vm/", {
      vm_uuid: action.vm_uuid
    });
    if (response.status === 200) {
      yield put(actions.rebuildVMSuccess(response.data, action.vm_uuid));
      yield put(
        showNotificationWithTimeout("virtualization", {
          status: NOTIFICATION_STATUS.success.name,
          msg: decodeHandler(response.data)
        })
      );
    } else {
      yield put(actions.rebuildVMFailure(action.vm_uuid));
      yield put(
        showNotificationWithTimeout("virtualization", {
          status: NOTIFICATION_STATUS.failure.name,
          msg:
            "Unable to rebuild the virtual instance " +
            decodeHandler(hostname) +
            ". Try again."
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(actions.rebuildVMFailure(action.vm_uuid));
    yield put(
      showNotificationWithTimeout("virtualization", {
        status: NOTIFICATION_STATUS.failure.name,
        msg:
          "Unable to rebuild the machine " +
          decodeHandler(hostname) +
          ". Try again later."
      })
    );
  }
}

export function* fetchVirtUserInfoStart(action) {
  try {
    const response = yield virtInstance.get(
      "/account/" + decryptData(localStorage.getItem("mirrorId")) + "/"
    );

    if (response.status === 200)
      yield put(actions.fetchVirtUserInfoSuccess(response.data));
    else if (response.status === 404) {
      yield put(actions.fetchVirtUserInfoFailureRetry());
    } else {
      yield put(actions.fetchVirtUserInfoFailure());
    }
  } catch (e) {
    console.log(e);
    yield put(actions.fetchVirtUserInfoFailure());
  }
}

export function* closeSSEConnection() {
  yield put(actions.logoutVirtInstances());
  try {
    console.log("SSE connection closed.");
    yield put(closeEventSourceConnection());
  } catch (e) {
    console.log(e);
  }
}

export function* logoutVirtInstances(params) {
  yield takeEvery(types.LOGOUT_VIRT_INSTANCES, function*(action) {
    const mirrorId = yield select(state => state.auth?.user?.mirrorId);
    const proxyTopic = yield select(
      state => state.virtualization?.rpcSocketDetailsVi?.proxy_topic
    );

    const ws = params.getRpcWebSocket();
    if (!ws) {
      yield call(waitForConnection, params.getRpcWebSocket, 1000);
    }
    const rpcSocket = params.getRpcWebSocket();
    if (!rpcSocket) return;

    const req = {
      message_type: "MESSAGE_BROADCAST",
      message_details: {
        viewer_mac_id: decryptData(localStorage.getItem("viewerId")),
        from_username: proxyTopic,
        type: "mirror_user_logout"
      }
    };
    rpcSocket.send(JSON.stringify(req));
  });
}

//retry virtualization console access for RPC machines with redirects
export function* handleRPCConsoleAccessStart(action) {
  const { clientUUID } = action;
  let retries = 0;
  const maxRetries = 6;
  const delayMs = 10000;

  const initialState = yield select(state => state.virtualization);
  if (!initialState.rpcConsoleAccessinProgressList?.[clientUUID]) {
    return;
  }

  while (retries < maxRetries) {
    const state = yield select(state => state.virtualization);
    const vmsList = state.vmsList;
    const rpcMachineStatusVi = state.rpcMachineStatusVi;
    const vm = vmsList.find(val => val.client_uuid === clientUUID);
    const vmRpcStatus = rpcMachineStatusVi?.find(
      item => item?.machine_id === vm?.rpc_mac_id
    );

    if (
      (vmRpcStatus?.host_status === "1" || vmRpcStatus?.host_status === "2") &&
      vmRpcStatus?.machine_id.includes("_")
    ) {
      // Success: Redirect and clean up
      redirectToRPCVirtualizationConsole(vmRpcStatus?.machine_id);
      yield put(actions.setRPCConsoleAccessInProgress(clientUUID)); // Remove from list
      return;
    } else {
      retries++;
      yield put(actions.fetchVMsListStart()); // Retry action
      yield delay(delayMs);
    }
  }

  // Failure: Fallback redirect and clean up
  const state = yield select(state => state.virtualization);
  const rpcConsoleAccessinProgressList = state.rpcConsoleAccessinProgressList;
  redirectToNoVNCVirtualizationConsole(
    rpcConsoleAccessinProgressList[clientUUID],
    clientUUID
  );
  yield put(actions.setRPCConsoleAccessInProgress(clientUUID)); // Remove from list
}

//retry virtualization console boot progress for RPC machines without redirects
export function* handleRPCBootProgressStart(action) {
  const { clientUUID } = action;
  let retries = 0;
  const maxRetries = 6;
  const delayMs = 10000;

  const initialState = yield select(state => state.virtualization);
  if (!initialState.rpcConsoleBootProgressList?.includes(clientUUID)) {
    return;
  }

  while (retries < maxRetries) {
    const state = yield select(state => state.virtualization);
    const vmsList = state.vmsList;
    const rpcMachineStatusVi = state.rpcMachineStatusVi;
    const vm = vmsList.find(val => val.client_uuid === clientUUID);
    const vmRpcStatus = rpcMachineStatusVi?.find(
      item => item?.machine_id === vm?.rpc_mac_id
    );

    if (
      (vmRpcStatus?.host_status === "1" || vmRpcStatus?.host_status === "2") &&
      vmRpcStatus?.machine_id.includes("_")
    ) {
      // Success
      yield put(actions.setRPCConsoleBootProgress(clientUUID)); // Remove from list
      return;
    } else {
      retries++;
      yield delay(delayMs);
    }
  }

  // Failure
  yield put(actions.setRPCConsoleBootProgress(clientUUID)); // Remove from list
}
